<template src="./reports.html"></template>
<script>
import Axios from "axios";
import $ from "jquery";
import { GChart } from "vue-google-charts";
import Multiselect from "vue-multiselect";
var moment = require("moment");

let type = "";
export default {
  components: { Multiselect },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    string: function (data) {
      var sendstring = "N/A";
      if (data != "" && data != null) {
        sendstring = data;
      }
      return sendstring;
    },
  },
  data() {
    return {
      VehicleFilterOptions: false,
      vehicleAdvanceFilter: false,
      driverAdvanceFilter: false,
      trailerAdvanceFilter: false,
      assetsAdvanceFilter: false,
      SearchVehicle: {},
      VehicleMakes: [],
      VehicleModels: [],
      VehicleYears: [],
      VehicleClasses: [],
      VehicleBranches: [],
      VehicleGroups: [],
      VehicleGroupsTmp: [],
      VehicleBranchesTmp: [],
      SearchDriver: {},
      SearchTrailer: {},
      SearchAsset: {},
      DriverPenalty: [],
      TrailerType: [],
      AssetResponsibility: [],
      AssetCategory: [],
      AssetSubCategory: [],
      AssetTrainingType: [],
      AssetSubCategoryTmp: [],
      AssetCategoryTmp: [],
      Records: [],
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      excel_data: [],
      excel_title: "",
      vehiclefilters: {
        keywords: {
          value: "",
          keys: [
            "vrm",
            "reg",
            "make",
            "model",
            "year",
            "class",
            "branch",
            "mot_due",
            "tax_due",
            "insurance_expiry",
            "transmission",
            "last_pmi_date",
            "nextservice_date",
            "nextservice_mile",
            "next_pmi_due",
            "assigend",
            "unsafe",
            "last_check_date",
          ],
        },
      },
      driverfilters: {
        keywords: {
          value: "",
          keys: [
            "name",
            "branch",
            "license_expiry",
            "assigned_vehicles",
            "license_number",
            "penality_points",
            "cpc_expiry",
            "adr_expiry",
            "license_codes",
            "accidents",
            "connect_via_mobile",
          ],
        },
      },
      trailerfilters: {
        keywords: {
          value: "",
          keys: [
            "vrm",
            "reg",
            "make",
            "model",
            "year",
            "branch",
            "last_pmi_date",
            "trailer_type",
            "capacity",
            "max_load_weight",
            "unladen_weight",
            "next_pmi_due",
            "assigend",
            "unsafe",
            "psv_date",
            "last_check_date",
            "exempt_psv",
          ],
        },
      },
      assetfilters: {
        keywords: {
          value: "",
          keys: [
            "name",
            "type",
            "responsibility",
            "serial_number",
            "make",
            "model",
            "year",
            "category_name",
            "subcategory_name",
            "training_type",
            "assigned_driver",
            "assigned_vehicle",
            "assigned_location",
            "unsafe",
            "last_check_date",
            "asset_missing",
          ],
        },
      },
      Type: "",
      ReportType: "",
      filter: {
        currentPage: 1,
        totalPages: 0,
      },
      ShowVehicle: false,
      ShowDriver: false,
      ShowAssets: false,
      ShowTrailers: false,
      vehiclecolumns: [
          // { key: 'vrm', label: 'VRM' },
          { key: 'make', label: 'Make' },
          { key: 'model', label: 'Model' },
          { key: 'year', label: 'Year' },
          { key: 'class', label: 'Class' },
          { key: 'branch', label: 'Branch' },
          { key: 'group', label: 'Group' },
          { key: 'transmission', label: 'Transmission' },
          { key: 'mot_due', label: 'MOT Expiry' },
          { key: 'tax_due', label: 'Tax Expiry' },
          { key: 'insurance_expiry', label: 'Insurance Expiry' },
          { key: 'nextservice_date', label: 'Next Service Date' },
          { key: 'nextservice_mile', label: 'Next Service Miles' },
          { key: 'next_pmi_due', label: 'Next PMI Date' },
          { key: 'assigend', label: 'Assigned to' },
          { key: 'unsafe', label: 'Safe Status' },
          { key: 'last_check_date', label: 'Last Checked' },
          { key: 'litres_used', label: 'Litres Used' },
          { key: 'total_spent', label: 'Total Spent(Service)' },
        ],
        drivercolumns: [
          { key: 'branch', label: 'Branch' },
          { key: 'assigned_vehicles', label: 'Assigned to' },
          { key: 'license_expiry', label: 'Licence Expiry' },
          { key: 'license_number', label: 'License Number' },
          { key: 'penality_points', label: 'Penality Points' },
          { key: 'cpc_expiry', label: 'CPC Expiry' },
          { key: 'adr_expiry', label: 'ADR Expiry to' },
          { key: 'license_codes', label: 'License Codes' },
          { key: 'accidents', label: 'Number of Accidents' },
          { key: 'connect_via_mobile', label: 'App Downloaded' },
        ],

         trailercolumns: [
          { key: 'make', label: 'Make' },
          { key: 'model', label: 'Model' },
          { key: 'year', label: 'Year' },
          { key: 'branch', label: 'Branch' },
          { key: 'trailer_type', label: 'Trailer Type' },
          { key: 'capacity', label: 'Capacity' },
          { key: 'max_load_weight', label: 'Max Load Weight' },
          { key: 'unladen_weight', label: 'Unladen Weight' },
          { key: 'last_pmi_date', label: 'PMI Expiry' },
          { key: 'next_pmi_due', label: 'Next PMI Date' },
          { key: 'psv_date', label: 'PSV Date' },
          { key: 'exempt_psv', label: 'Exempt PSV' },
          { key: 'assigend', label: 'Assigned to' },
          { key: 'unsafe', label: 'Safe Status' },
          { key: 'last_check_date', label: 'Last Checked' },
        ],

        assetcolumns: [
          { key: 'type', label: 'Type' },
          { key: 'responsibility', label: 'Responsibility' },
          { key: 'serial_number', label: 'Serial Number' },
          { key: 'make', label: 'Make' },
          { key: 'model', label: 'Model' },
          { key: 'year', label: 'Year' },
          { key: 'category_name', label: 'Category' },
          { key: 'subcategory_name', label: 'Sub-category' },
          { key: 'training_type', label: 'Training Type' },
          { key: 'group_name', label: 'Group' },
          { key: 'assigned_driver', label: 'Assigned Driver' },
          { key: 'assigned_vehicle', label: 'Assigned Vehicle' },
          { key: 'assigned_location', label: 'Assigned Location' },
          { key: 'unsafe', label: 'Safe Status' },
          { key: 'last_check_date', label: 'Last Checked' },
          { key: 'asset_missing', label: 'Reported Missing' },
        ],

        // Track which columns are visible
        vehicleVisibleColumns: {},
        driverVisibleColumns: {},
        trailerVisibleColumns: {},
        assetVisibleColumns: {},
        showColumnFilter: false, // controls dropdown visibility
        tempVehicleVisibleColumns: {},
        tempDriverVisibleColumns: {},
        tempTrailerVisibleColumns: {},
        tempAssetVisibleColumns: {},

    };
  },
  mounted() {
     this.vehiclecolumns.forEach(c => {
      this.vehicleVisibleColumns[c.key] = true;
      this.tempVehicleVisibleColumns[c.key] = true;
    });

    this.drivercolumns.forEach(c => {
      this.driverVisibleColumns[c.key] = true;
      this.tempDriverVisibleColumns[c.key] = true;
    });

    this.trailercolumns.forEach(c => {
      this.trailerVisibleColumns[c.key] = true;
      this.tempTrailerVisibleColumns[c.key] = true;
    });

    this.assetcolumns.forEach(c => {
      this.assetVisibleColumns[c.key] = true;
      this.tempAssetVisibleColumns[c.key] = true;
    });

    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(FleetSubscription.fleet_modules);
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions.Reports || !AccountPermissions.Reports.enable)
    ) {
      this.$router.push("/");
    }
    if (AccountPermissions.Driver && AccountPermissions.Driver.enable) {
      this.ShowDriver = true;
    }
    if (AccountPermissions.Vehicle && AccountPermissions.Vehicle.enable) {
      this.ShowVehicle = true;
    }
    if (AccountPermissions.Assets && AccountPermissions.Assets.enable) {
      this.ShowAssets = true;
    }
    if (AccountPermissions.Trailers && AccountPermissions.Trailers.enable) {
      this.ShowTrailers = true;
    }
    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowVehicle = true;
      this.ShowDriver = true;
      this.ShowAssets = true;
      this.ShowTrailers = true;
    }
    const isAssets = FleetSubscriptionModules.Assets;
    if (!isAssets) {
      this.ShowAssets = false;
    }
    const isTrailer = FleetSubscriptionModules.Trailers;
    if (!isTrailer) {
      this.ShowTrailers = false;
    }

    document.title = pbx_SiteTitle + " - Reports Table";
    
    var vehicleVisibleColumns = JSON.parse( localStorage.getItem("vehicleVisibleColumns") );    
    if(vehicleVisibleColumns){
      this.vehicleVisibleColumns = vehicleVisibleColumns;
    }

    var driverVisibleColumns = JSON.parse( localStorage.getItem("driverVisibleColumns") );    
    if(driverVisibleColumns){
      this.driverVisibleColumns = driverVisibleColumns;
    }

  },

  methods: {

  formatLabel(key) {
    return key
      .replace(/_/g, ' ')
      .replace(/\b\w/g, l => l.toUpperCase());
  },
  isDateField(key) {
    // Automatically detect date-type fields
    return /(date|_due|expiry|created|updated)$/i.test(key);
  },

  formatDate(value) {
    if (!value) return 'N/A'; // handles null, '', undefined
    const date = new Date(value);
    // Check if the date is valid
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  },

    toggleColumnDropdown() {
      this.VehicleFilterOptions = false;
      this.vehicleAdvanceFilter = false;
      this.driverAdvanceFilter = false;
      this.trailerAdvanceFilter = false;
      this.assetsAdvanceFilter = false;
      this.showColumnFilter = !this.showColumnFilter;
      // Copy current state to temp before showing
      if (this.showColumnFilter) {
        this.tempVehicleVisibleColumns = { ...this.vehicleVisibleColumns };
        this.tempDriverVisibleColumns = { ...this.driverVisibleColumns };
        this.tempTrailerVisibleColumns = { ...this.trailerVisibleColumns };
        this.tempAssetVisibleColumns = { ...this.assetVisibleColumns };
      }
    },

    applyVehicleColumnFilter() {
      // Copy temporary selections to active visibility
      this.vehicleVisibleColumns = { ...this.tempVehicleVisibleColumns };
      this.showColumnFilter = false; // close dropdown
      // Optional: Persist
      localStorage.setItem('vehicleVisibleColumns', JSON.stringify(this.vehicleVisibleColumns));
    },

    applyDriverColumnFilter() {
      // Copy temporary selections to active visibility
      this.driverVisibleColumns = { ...this.tempDriverVisibleColumns };
      this.showColumnFilter = false; // close dropdown
      // Optional: Persist
      localStorage.setItem('driverVisibleColumns', JSON.stringify(this.driverVisibleColumns));
    },

    applyTrailerColumnFilter() {
      // Copy temporary selections to active visibility
      this.trailerVisibleColumns = { ...this.tempTrailerVisibleColumns };
      this.showColumnFilter = false; // close dropdown
      // Optional: Persist
      localStorage.setItem('trailerVisibleColumns', JSON.stringify(this.trailerVisibleColumns));
    },

    applyAssetColumnFilter() {
      // Copy temporary selections to active visibility
      this.assetVisibleColumns = { ...this.tempAssetVisibleColumns };
      this.showColumnFilter = false; // close dropdown
      // Optional: Persist
      localStorage.setItem('assetVisibleColumns', JSON.stringify(this.assetVisibleColumns));
    },

    changeType() {
      this.Records = [];
      this.VehicleFilterOptions = false;
      //this.SearchVehicle = [];
      this.VehicleMakes = [];
      this.VehicleModels = [];
      this.VehicleYears = [];
      this.VehicleClasses = [];
      this.VehicleBranches = [];
      this.VehicleGroups = [];
      this.VehicleGroupsTmp = [];
      this.VehicleBranchesTmp = [];
      this.DriverPenalty = [];
      this.TrailerType = [];
      this.AssetResponsibility = [];
      this.AssetCategory = [];
      this.AssetSubCategory = [];
      this.AssetTrainingType = [];
      this.AssetSubCategoryTmp = [];
      this. AssetCategoryTmp = [];
      this.ReportType = "";
    },
    ShowFilters() {
      this.showColumnFilter = false;
      if (this.ReportType == "Vehicle") {
        if (!this.vehicleAdvanceFilter) {
          this.vehicleAdvanceFilter = true;
        } else {
          this.vehicleAdvanceFilter = false;
        }
      } else if (this.ReportType == "Driver") {
        if (!this.driverAdvanceFilter) {
          this.driverAdvanceFilter = true;
        } else {
          this.driverAdvanceFilter = false;
        }
      } else if (this.ReportType == "Trailer") {
        if (!this.trailerAdvanceFilter) {
          this.trailerAdvanceFilter = true;
        } else {
          this.trailerAdvanceFilter = false;
        }
      } else if (this.ReportType == "Asset") {
        if (!this.assetsAdvanceFilter) {
          this.assetsAdvanceFilter = true;
        } else {
          this.assetsAdvanceFilter = false;
        }
      }
    },
    SearchVehicleReset() {
      this.SearchVehicle = {};
      this.GetReport();
    },
    SearchDriverReset() {
      this.SearchDriver = {};
      this.GetReport();
    },
    SearchTrailerReset() {
      this.SearchTrailer = {};
      this.GetReport();
    },
    SearchAssetReset() {
      this.SearchAsset = {};
      this.GetReport();
    },
    GetReport() {
      this.ShowLoader = true;
      this.ReportType = this.Type;
      this.Records = [];
      if (this.Type == "") {
        this.$swal("Please select report type", "", "error");
        this.ShowLoader = false;
      }
      if (this.ReportType == "Vehicle") {
        var obj = {
          token: localStorage.getItem("token"),
          search_key: this.SearchVehicle,
        };
        Axios.post(Endpoints.ReportsTable.VehiclesList, obj).then(
          (Response) => {
            if (Response?.data?.success) {
              this.Records = Response.data.vehicles;
              this.ShowLoader = false;
              this.excel_data = [];
              if (this.Records.length > 0) {
                this.vehicleAdvanceFilter = false;

               // after fetching data
                  const excludeKeys = ['vrm', 'id', 'owner_id', 'group_id', 'company_id', 'branch_id'];
                  const recordKeys = Object.keys(this.Records[0]).filter(key => !excludeKeys.includes(key));

                  recordKeys.forEach(key => {
                    const exists = this.vehiclecolumns.some(col => col.key === key);
                    if (!exists) {
                      this.vehiclecolumns.push({
                        key,
                        label: this.formatLabel(key)
                      });
                    }
                  });

                  // // set visibility
                  // this.vehiclecolumns.forEach(c => {
                  //   this.vehicleVisibleColumns[c.key] = false;
                  //   this.tempVehicleVisibleColumns[c.key] = false;
                  // });
                
                this.Records.forEach((element2) => {
                  if (!this.VehicleFilterOptions) {
                    if (!this.VehicleMakes.includes(element2.make)) {
                      this.VehicleMakes.push(element2.make);
                    }

                    if (!this.VehicleModels.includes(element2.model)) {
                      this.VehicleModels.push(element2.model);
                    }

                    if (!this.VehicleYears.includes(element2.year)) {
                      this.VehicleYears.push(element2.year);
                    }
                    if (!this.VehicleClasses.includes(element2.class)) {
                      this.VehicleClasses.push(element2.class);
                    }
                    if (!this.VehicleBranchesTmp.includes(element2.branch)) {
                      this.VehicleBranches.push({
                        id: element2.branch_id,
                        title: element2.branch,
                      });
                      this.VehicleBranchesTmp.push(element2.branch);
                    }
                    if (!this.VehicleGroupsTmp.includes(element2.group)) {
                      this.VehicleGroups.push({
                        id: element2.group_id,
                        title: element2.group,
                      });
                      this.VehicleGroupsTmp.push(element2.group);
                    }
                  }                  

                  const obj = {};
                  obj['VRM'] = element2.vrm;
                  this.vehiclecolumns.forEach(col => {
                    const label = col.label;
                    const key = col.key;
                    let value = element2[key];

                    // 1️⃣ Auto-format date fields
                    if (key.toLowerCase().includes('date') || key.toLowerCase().includes('expiry') || key.toLowerCase().includes('due')) {
                      value = this.$options.filters.date(value);
                    }

                    // 2️⃣ Boolean or numeric flag formatting
                    if (typeof value === 'boolean') {
                      value = value ? 'Yes' : 'No';
                    } else if (value === 1 || value === 0) {
                      // Handle specific flags
                      if (key.toLowerCase().includes('expired') || key.toLowerCase().includes('unsafe')) {
                        value = value === 1 ? 'Yes' : 'No';
                      }
                    }

                    // 3️⃣ Special derived fields
                    if (key === 'unsafe') value = element2.unsafe == 1 ? 'No' : 'Yes';
                    if (key === 'driver' && element2.driver) {
                      // Driver is a single object
                      value = `${element2.driver.driver.forename || ''} ${element2.driver.driver.surname || ''}`.trim();
                    }

                    // 4️⃣ Fallback for null/undefined
                    if (value === null || value === undefined || value === '') {
                      value = 'N/A';
                    }

                    obj[label] = value;
                  });
                 
                  this.excel_data.push(obj);
                });
                this.VehicleFilterOptions = true;
              }
            }
          }
        );
      } else if (this.ReportType == "Trailer") {
        var obj = {
          token: localStorage.getItem("token"),
          search_key: this.SearchTrailer,
        };
        Axios.post(Endpoints.ReportsTable.TrailersList, obj).then(
          (Response) => {
            if (Response?.data?.success) {
              this.Records = Response.data.trailers;
              this.ShowLoader = false;
              this.excel_data = [];
              this.trailerAdvanceFilter = false;
              if (this.Records.length > 0) {

               //set field labels
                const excludeKeys = ['vrm','id', 'owner_id', 'company_id', 'group_id', 'branch_id','get_trailer',"vehicle_check"];
                const recordKeys = Object.keys(this.Records[0]).filter(key => !excludeKeys.includes(key));
                recordKeys.forEach(key => {
                  const exists = this.trailercolumns.some(col => col.key === key);
                  if (!exists) {
                    this.trailercolumns.push({
                      key,
                      label: this.formatLabel(key)
                    });
                  }
                });

                this.Records.forEach((element2) => {
                  if (!this.VehicleFilterOptions) {
                    if (
                      element2.make != "" &&
                      !this.VehicleMakes.includes(element2.make)
                    ) {
                      this.VehicleMakes.push(element2.make);
                    }
                    if (
                      element2.model != "" &&
                      !this.VehicleModels.includes(element2.model)
                    ) {
                      this.VehicleModels.push(element2.model);
                    }
                    if (
                      element2.year != "" &&
                      !this.VehicleYears.includes(element2.year)
                    ) {
                      this.VehicleYears.push(element2.year);
                    }
                    if (!this.VehicleBranchesTmp.includes(element2.branch)) {
                      this.VehicleBranches.push({
                        id: element2.branch_id,
                        title: element2.branch,
                      });
                      this.VehicleBranchesTmp.push(element2.branch);
                    }
                    if (
                      element2.trailer_type != "" &&
                      !this.TrailerType.includes(element2.trailer_type)
                    ) {
                      this.TrailerType.push(element2.trailer_type);
                    }
                  }
                  var obj = {};
                  obj["VRM"] = element2.vrm;
                  this.trailercolumns.forEach(col => {
                      const label = col.label;
                      const key = col.key;
                      let value = element2[key];

                      // 1️⃣ Handle date fields automatically
                      if (
                        key.toLowerCase().includes('date') ||
                        key.toLowerCase().includes('expiry') ||
                        key.toLowerCase().includes('due')
                      ) {
                        value = this.$options.filters.date(value);
                      }

                      // 2️⃣ Handle string-type normalization (if your filter exists)
                      if (typeof value === 'string') {
                        value = this.$options.filters.string(value);
                      }

                      // 3️⃣ Handle special cases
                      if (key === 'exempt_psv') value = element2.exempt_psv == 1 ? 'No' : 'Yes';
                      if (key === 'unsafe') value = element2.unsafe == 1 ? 'No' : 'Yes';

                      if (key === 'assigend') {
                        if (element2.get_trailer) {
                          const trailerData = element2.get_trailer.trailer_data;
                          value = trailerData?.vrm || 'N/A';
                        } else {
                          value = 'N/A';
                        }
                      }

                      // 4️⃣ Fallback for null/empty
                      if (value === null || value === undefined || value === '') {
                        value = 'N/A';
                      }

                      // 5️⃣ Add final key-value to export object
                      obj[label] = value;
                    });

                    this.excel_data.push(obj);
                });
              }
            }
          }
        );
      } else if (this.ReportType == "Driver") {
        var obj = {
          token: localStorage.getItem("token"),
          search_key: this.SearchDriver,
        };
        Axios.post(Endpoints.ReportsTable.DriversList, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Records = Response.data.drivers;
            this.ShowLoader = false;
            this.excel_data = [];
            this.driverAdvanceFilter = false;
            if (this.Records.length > 0) {

            //set field labels
              const excludeKeys = ['name','id', 'owner_id','company_id', 'branch_id', 'forename', 'surname', 'driver_vehicle'];
              const recordKeys = Object.keys(this.Records[0]).filter(key => !excludeKeys.includes(key));
                recordKeys.forEach(key => {
                  const exists = this.drivercolumns.some(col => col.key === key);
                  if (!exists) {
                    this.drivercolumns.push({
                      key,
                      label: this.formatLabel(key)
                    });
                  }
                });

              this.Records.forEach((element2) => {
                if (!this.VehicleFilterOptions) {
                  if (
                    !this.DriverPenalty.includes(element2.penality_points) &&
                    element2.penality_points != ""
                  ) {
                    this.DriverPenalty.push(element2.penality_points);
                  }
                  if (!this.VehicleBranchesTmp.includes(element2.branch)) {
                    this.VehicleBranches.push({
                      id: element2.branch_id,
                      title: element2.branch,
                    });
                    this.VehicleBranchesTmp.push(element2.branch);
                  }
                }

                var obj = {};
                obj["Name"] = element2.name;                           
                  this.drivercolumns.forEach(col => {
                    const label = col.label; // column name for Excel header
                    const key = col.key;     // property name in element2
                    let value = element2[key];

                    // 1️⃣ Handle date fields (license_expiry, cpc_expiry, adr_expiry)
                    if (
                      key.toLowerCase().includes('date') ||
                      key.toLowerCase().includes('expiry') ||
                      key.toLowerCase().includes('due')
                    ) {
                      value = this.$options.filters.date(value);
                      if (value === '01 Jan 1970' || !value) value = 'N/A';
                    }

                    // 2️⃣ Handle assigned vehicles (array of vehicle objects)
                    if (key === 'assigned_vehicles' || key === 'driver_vehicle') {
                      if (Array.isArray(element2.driver_vehicle) && element2.driver_vehicle.length > 0) {
                        value = element2.driver_vehicle
                          .map(v => v.vehicle?.vrm || '')
                          .filter(vrm => vrm !== '')
                          .join(', ');
                      } else {
                        value = 'N/A';
                      }
                    }

                    // 3️⃣ License number, codes, etc. → handle empty strings
                    if (['license_number', 'license_codes'].includes(key)) {
                      value = value && value.trim() !== '' ? value : 'N/A';
                    }

                    // 4️⃣ Penalty points default to 0 if empty
                    if (key === 'penality_points') {
                      value = value > 0 ? value : 0;
                    }

                    // 5️⃣ Fallback for empty/null/undefined
                    if (value === null || value === undefined || value === '') {
                      value = 'N/A';
                    }

                    // 6️⃣ Assign to Excel export object using the label
                    obj[label] = value;
                  });

                  this.excel_data.push(obj);
              });
            }
          }
        });
      } else if (this.ReportType == "Asset") {
        var obj = {
          token: localStorage.getItem("token"),
          search_key: this.SearchAsset,
        };
        Axios.post(Endpoints.ReportsTable.AssetsList, obj).then((Response) => {
          if (Response?.data?.success) {
            this.Records = Response.data.assets;
            this.ShowLoader = false;
            this.excel_data = [];
            this.assetsAdvanceFilter = false;
            if (this.Records.length > 0) {

               //set field labels
                const excludeKeys = ['name','id', 'owner_id', 'user_id', 'company_id', 'branch_id', 'additional_photos','asset_check','asset_check_settings','assignments', 'assigned_vehicle_plate'];
                
                const recordKeys = Object.keys(this.Records[0]).filter(key => !excludeKeys.includes(key));
                recordKeys.forEach(key => {
                  const exists = this.assetcolumns.some(col => col.key === key);
                  if (!exists) {
                    this.assetcolumns.push({
                      key,
                      label: this.formatLabel(key)
                    });
                  }
                });

              this.Records.forEach((element2) => {
                if (!this.VehicleFilterOptions) {
                  if (
                    element2.type != "" &&
                    !this.TrailerType.includes(element2.type)
                  ) {
                    this.TrailerType.push(element2.type);
                  }
                  if (
                    element2.responsibility != "" &&
                    !this.AssetResponsibility.includes(element2.responsibility)
                  ) {
                    this.AssetResponsibility.push(element2.responsibility);
                  }
                  if (
                    element2.make != "" &&
                    !this.VehicleMakes.includes(element2.make)
                  ) {
                    this.VehicleMakes.push(element2.make);
                  }
                  if (
                    element2.model != "" &&
                    !this.VehicleModels.includes(element2.model)
                  ) {
                    this.VehicleModels.push(element2.model);
                  }
                  if (
                    element2.year != "" &&
                    !this.VehicleYears.includes(element2.year)
                  ) {
                    this.VehicleYears.push(element2.year);
                  }

                  if (!this.AssetCategoryTmp.includes(element2.category_name)) {
                    this.AssetCategory.push({
                      id: element2.category,
                      title: element2.category_name,
                    });
                    this.AssetCategoryTmp.push(element2.category_name);
                  }
                  if (
                    !this.AssetSubCategoryTmp.includes(
                      element2.subcategory_name
                    )
                  ) {
                    this.AssetSubCategory.push({
                      id: element2.sub_category,
                      title: element2.subcategory_name,
                    });
                    this.AssetSubCategoryTmp.push(element2.subcategory_name);
                  }
                  if (
                    element2.training_type != "" &&
                    !this.AssetTrainingType.includes(element2.training_type)
                  ) {
                    this.AssetTrainingType.push(element2.training_type);
                  }
                }
                var obj = {};
                obj["Name"] = element2.name;
                this.assetcolumns.forEach(col => {
                const label = col.label;
                const key = col.key;
                let value = element2[key];

                // 1️⃣ Handle date fields automatically
                if (
                  key.toLowerCase().includes('date') ||
                  key.toLowerCase().includes('expiry') ||
                  key.toLowerCase().includes('due')
                ) {
                  value = this.$options.filters.date(value);
                }

                // 2️⃣ Handle string normalization
                if (typeof value === 'string') {
                  value = this.$options.filters.string(value);
                }

                // 3️⃣ Handle special cases
                if (key === 'unsafe') value = element2.unsafe == 1 ? 'No' : 'Yes';
                if (key === 'assigned_vehicle') {
                  if (Array.isArray(element2.assigned_vehicle_plate) && element2.assigned_vehicle_plate.length > 0) {
                    value = element2.assigned_vehicle_plate.join(', ');
                  } else {
                    value = 'N/A';
                  }
                }

                // 4️⃣ Handle null or empty values
                if (value === null || value === undefined || value === '') {
                  value = 'N/A';
                }

                // 5️⃣ Add formatted key-value pair
                obj[label] = value;
              });

              this.excel_data.push(obj);
              });
            }
          }
        });
      }
    },
  },
};
</script>

<style type="text/css">
.plate-display {
  display: inline-block;
}
.vehiclelist th:first-child {
  background: #fff !important;
}
.vehiclelist th:first-child {
  min-width: 130px;
}
.vehiclelist th:first-child,
.vehiclelist td:first-child {
  position: sticky;
  left: -1px;
  background: #fff !important;
  z-index: 5;
  top:1px;
}
.vehiclelist td:first-child {
  position: sticky;
  left: -1px;
  background: #fff !important;
  z-index: 2;
}
.custom-scrollbar2 thead th {
  position: sticky;
  top: -1px;
  background: #fff;
  z-index: 4;
}
.datatable-vue table tbody tr:nth-child(odd) td {
  background-color: #f9f9f9 !important;
}
.datatable-vue table tbody tr:hover td {
  background-color: #f9f9f9 !important;
}
.vehiclelist th {
  min-width: 150px !important;
}
.custom-scrollbar thead th.heading-padding-left {
  padding-left: 0.75rem !important;
}
g {
  cursor: pointer;
}
.margin-auto {
  margin: 0 auto;
}
.vehicle-details-modal {
  width: 100%;
}
.margin-right-auto {
  margin-right: auto !important;
}
.detail-link {
  color: #000;
}
.detail-link:hover {
  color: #000;
}
#showOwnerDetails .modal-header {
  border-bottom: 0px !important;
}
#showOwnerDetails .modal-title {
  font-size: 14px !important;
}
.modal-table .table th,
.table td {
  padding: 0.75rem !important;
}
.vehicle-info-modal,
.owner-info-modal {
  padding-top: 0px !important;
}
#showVehicleDetails .modal-header {
  border-bottom: 0px !important;
}
#showVehicleDetails .modal-title {
  font-size: 14px !important;
}
.date-box {
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  padding-top: 10px;
}
.mt-10 {
  margin-top: 20px;
}
.d_non {
  display: none;
}
@media (max-width: 767px) {
  .custom_search {
    position: absolute !important;
    right: 0px !important;
    width: 378px !important;
    height: 400px !important;
    background-color: #f9f9f9 !important;
    -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2) !important;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2) !important;
    border: none !important;
    z-index: 999 !important;
    top: 46px !important;
  }
}
.custom_search {
  position: absolute;
  right: 15px;
  width: 460px;
  height: 400px;
  background-color: #f9f9f9;
  -webkit-box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  border: none;
  z-index: 1;
}
.custom_search_form {
  padding: 10px;
  height: 349px;
  overflow-y: auto;
}
.search_field {
  width: 100%;
  margin-top: 10px;
}
.cursor-pointer {
  cursor: pointer !important;
}
.custom_search_button_div {
  padding: 10px;
  background-color: #ededf2;
  border-top: 1px solid #ededf2;
  text-align: right;
}
.filter-dropdown {
  position: absolute;
  top: 40px;
  right: 5px;
  background: white;
  border-radius: 8px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  width: 270px;
  z-index: 99;
  background-color: #f9f9f9;
}
.filter-dropdown h3{
    text-align: left;
    font-size: 15px !important;
    border-bottom: 1px solid #ccc;
    padding: 15px 15px 10px;
}
.filter-option {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin: 4px 0;
  text-align: center;
}
</style>
